<template>
	<div id="body">
		<!-- Page Loader -->
		<div class="page-loader-wrapper" v-if="isCarregando == true">
			<div class="loader">
				<div class="loader_a"></div>
				
			</div>
		</div>

		<!-- Overlay For Sidebars -->
		<div class="overlay"></div>

		<div id="wrapper" v-if="isLogado" :class="dadosEscola.id != null ? '' : 'd-none'">
			<!-- Page top navbar -->
			<NavBar />
        
			<!-- Main left sidebar menu -->
			<Lateral />
        
			<!-- Stiky note div  -->
			<div class="sticky-note">
				<a href="javascript:void(0);" class="right_note"><i class="fa fa-close"></i></a>
				<div class="form-group c_form_group">
					<label>Write your note here</label>
					<div class="input-group">
						<input type="text" class="form-control" placeholder="Enter here...">
						<div class="input-group-append"><button class="btn btn-dark btn-sm" type="button">Add</button></div>
					</div>
				</div>
				<div class="note-body">
					<div class="card note-item">
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span class="font-10 text-muted">12 Apr 2020</span>
							</div>
							<div>
								<a href="javascript:void(0);" class="star"><i class="fa fa-star-o"></i></a>
								<a href="javascript:void(0);" class="delete"><i class="fa fa-trash"></i></a>
							</div>
						</div>
						<div class="note-detail">
							<span>Commit code on github branch development</span>
						</div>
					</div>
					<div class="card note-item">
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span class="font-10 text-muted">12 Apr 2020</span>
							</div>
							<div>
								<a href="javascript:void(0);" class="star active"><i class="fa fa-star-o"></i></a>
								<a href="javascript:void(0);" class="delete"><i class="fa fa-trash"></i></a>
							</div>
						</div>
						<div class="note-detail">
							<span>Meeting with client for new project.</span>
						</div>
					</div>
					<div class="card note-item">
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span class="font-10 text-muted">12 Apr 2020</span>
							</div>
							<div>
								<a href="javascript:void(0);" class="star"><i class="fa fa-star-o"></i></a>
								<a href="javascript:void(0);" class="delete"><i class="fa fa-trash"></i></a>
							</div>
						</div>
						<div class="note-detail">
							<span>making this the first true generator on the Internet</span>
						</div>
					</div>
					<div class="card note-item">
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span class="font-10 text-muted">12 Apr 2020</span>
							</div>
							<div>
								<a href="javascript:void(0);" class="star"><i class="fa fa-star-o"></i></a>
								<a href="javascript:void(0);" class="delete"><i class="fa fa-trash"></i></a>
							</div>
						</div>
						<div class="note-detail">
							<span>it look like readable English. Many desktop publishing</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Main body part  -->
			<div v-if="dadosEscola.id != null" id="main-content">
				<div class="container-fluid">
					<router-view class="pt-4" />
				</div>
			</div>
		</div>

		<Escolas v-if="isLogado && dadosEscola.id == null" />
		<Login v-if="!isLogado" />
	</div>
</template>

<script>

import { mapState } from 'vuex'
import Login from '@/views/Login.vue'
import NavBar from '@/components/MenuNavBar.vue'
import Escolas from '@/views/Escolas.vue'
import Lateral from '@/components/MenuLateral.vue'

export default {
	name: 'App',
	computed: {
		... mapState({
			dadosEscola: state => state.dadosEscola,
			isCarregando: state => state.isCarregando,
			isLogado: state => state.isLogado
		})
	},
	watch: {
		isLogado : function(value) {
			if (value) {
				require("@/assets/vendor/bootstrap/js/bootstrap.bundle.js")
			}
		}
	},
	components: {
		Lateral, NavBar, Login, Escolas
	},
	mounted(){
		this.$store.dispatch('verificarCredenciais')
   }
}

</script>

<style scoped>
	.loader_a {
  width: 8px;
  height: 40px;
  border-radius: 4px;
  display: block;
  background-color: currentColor;
  margin: 20px auto;
  position: relative;
  color: #0392CF;
  animation: animloader 0.3s 0.3s linear infinite alternate;
}

.loader_a::after,
.loader_a::before {
  content: '';
  width: 8px;
  height: 40px;
  border-radius: 4px;
  background: currentColor;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  animation: animloader 0.3s 0.45s linear infinite alternate;
}

.loader_a::before {
  left: -20px;
  animation-delay: 0s;
}

@keyframes animloader {
  0% {
    height: 48px;
  }

  100% {
    height: 4px;
  }
}
</style>